import { render, staticRenderFns } from "./ApplicationsUpdated.vue?vue&type=template&id=01e8d075&"
import script from "./ApplicationsUpdated.vue?vue&type=script&lang=ts&"
export * from "./ApplicationsUpdated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports